export default __webpack_public_path__ + "static/media/companies-clarin.0250d2e2.svg";